<template>
  <div class="yxtbiz-teacher-subscribe-audit">
    <div v-loading="loading" class="standard-size-16 color-gray-10">
      <div class="mb24 font-bolder">
        {{$t('pc_signup_tit_applicant'/* 申请人信息 */)}}
        <yxtf-row type="flex" class="mv24 font-normal font-size-14">
          <yxtf-col :span="12" class="nowrap mh2 felx-center">
            <span class="color-gray-7">{{$t('pc_biz_signup_lbl_name'/* 姓名 */)}}：</span>
            <yxtf-tooltip
              :open-filter="true"
              placement="top">
              <div slot="content">
                <span>
                  <yxtbiz-user-name :name="baseInfo.teName || '--'" />（{{baseInfo.teUserName || '--'}}）
                </span>
              </div>
              <div class="yxtbiz-teacher-enroll-audit_ellipsis">
                <span>
                  <yxtbiz-user-name :name="baseInfo.teName || '--'" />（{{baseInfo.teUserName || '--'}}）
                </span>
              </div>
            </yxtf-tooltip>
          </yxtf-col>
          <yxtf-col :span="12" class="nowrap mh2 felx-center">
            <span class="color-gray-7">{{$t('pc_biz_signup_lbl_deptname'/* 部门 */)}}：</span>
            <yxtf-tooltip
              :open-filter="true"
              placement="top">
              <div slot="content">
                <yxtbiz-dept-name :name="baseInfo.teDeptName || '--'" />
              </div>
              <div class="yxtbiz-teacher-enroll-audit_ellipsis">
                <yxtbiz-dept-name :name="baseInfo.teDeptName || '--'" />
              </div>
            </yxtf-tooltip>
          </yxtf-col>
        </yxtf-row>
      </div>
      <div class="mb24 font-bolder">
        {{$t('pc_biz_te_lbl_subscribe_info'/* 预约信息 */)}}
        <yxtf-row type="flex" class="mv24 font-normal font-size-14">
          <yxtf-col :span="12" class="nowrap mh2 felx-center">
            <span class="color-gray-7">{{$t('pc_biz_survey_lbl_name'/* 名称 */)}}：</span>
            <yxtf-tooltip
              v-if="baseInfo.targetName"
              :open-filter="true"
              :content="baseInfo.targetName"
              placement="top">
              <div class="yxtbiz-teacher-subscribe-audit_ellipsis">{{baseInfo.targetName}}</div>
            </yxtf-tooltip>
            <div v-else>--</div>
          </yxtf-col>
          <yxtf-col :span="12" class="nowrap mh2 felx-center">
            <span class="color-gray-7">{{$t('pc_biz_survey_lbl_type'/* 类型 */)}}：</span>
            <span>{{ $t(getTargetType(baseInfo.targetType)) || '--'}}</span>
          </yxtf-col>
        </yxtf-row>
        <yxtf-row type="flex" class="mb24 font-normal font-size-14">
          <yxtf-col :span="12" class="nowrap mh2 felx-center">
            <span class="color-gray-7">{{$t('pc_biz_te_subscribe_time'/* 预约时段 */)}}：</span>
            <span>{{ `${baseInfo.apptStartDate || '--'} ~ ${baseInfo.apptEndDate || '--'}` }}</span>
          </yxtf-col>
          <yxtf-col :span="12" class="nowrap mh2 felx-center">
            <span class="color-gray-7">{{$t('pc_biz_te_lbl_progress'/* 进度 */)}}：</span>
            <span> {{ `(${baseInfo.passFormalNums || 0} / ${baseInfo.maxApptNums || 0})` }} </span>
          </yxtf-col>
        </yxtf-row>
        <yxtf-row type="flex" class="font-normal font-size-14">
          <yxtf-col :span="12" class="nowrap mh2 felx-center">
            <span class="color-gray-7">{{$t('pc_biz_ote_lbl_principal'/* 负责人 */)}}：</span>
            <yxtf-tooltip
              v-if="baseInfo.directors"
              :open-filter="true"
              :content="baseInfo.directors"
              placement="top">
              <div class="yxtbiz-teacher-subscribe-audit_ellipsis">{{baseInfo.directors}}</div>
            </yxtf-tooltip>
            <div v-else>--</div>
          </yxtf-col>
        </yxtf-row>
      </div>
      <div class="font-bolder">
        {{$t('pc_biz_lbl_course_detail'/* 课程详情 */)}}
        <yxtf-row type="flex" class="mv24 font-normal font-size-14">
          <yxtbiz-flip-info v-if="baseInfo.targetId" :taskId="baseInfo.targetId" />
        </yxtf-row>
      </div>
    </div>
  </div>
</template>

<script>
import { getSubscribeDetail } from './service';
import Empty from './components/empty.vue';

export default {
  name: 'YxtbizTeacherSubscribeAudit',
  name_zh: '讲师预约审核信息',
  eventList: [
  ],
  components: {
    Empty
  },
  props: {
    // 预约任务ID
    formId: {
      type: String,
      default: '',
      desc: '审核 formId',
      setter: 'StringSetter'
    }
  },
  data() {
    return {
      loading: false,
      baseInfo: {} // 审核信息
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      if (!this.formId) return false;
      this.loading = true;
      getSubscribeDetail({ id: this.formId })
        .then(result => {
          this.baseInfo = result || {};
        }).catch(e => {
        }).finally(() => {
          this.loading = false;
        });
    },
    getTargetType(type) {
      switch (type) {
        case 0:
          return 'pc_biz_o2o_lbl_facetoface';
        default:
          return 'pc_biz_o2o_lbl_facetoface';
      }
    }
  }
};
</script>
